import p12_img from "./product_12.png";
import p14_img from "./product_14.png";
import p15_img from "./product_15.png";
import p17_img from "./product_17.png";
import p2_img from "./product_2.png";
import p28_img from "./product_28.png";
import p35_img from "./product_35.png";
import p8_img from "./product_8.png";

let new_collections = [
  {
    id: 12,
    name: "Cozy Women's Sportswear Sweater for Outdoor Activities",
    category: "women",
    image: p12_img,
    new_price: 75.0,
    old_price: 110.0,
  },
  {
    id: 35,
    name: "Elegant Kid's Long Wool Coat for Special Events",
    category: "kid",
    image: p35_img,
    new_price: 95.0,
    old_price: 125.0,
  },
  {
    id: 14,
    name: "Men's Checkered Button-Down Shirt for a Stylish Look",
    category: "men",
    image: p14_img,
    new_price: 70.0,
    old_price: 100.5,
  },
  {
    id: 8,
    name: "Comfortable Women's Nightwear Set",
    category: "women",
    image: p8_img,
    new_price: 45.0,
    old_price: 80.0,
  },
  {
    id: 15,
    name: "Traditional Men's Panjabi with Intricate Embroidery",
    category: "men",
    image: p15_img,
    new_price: 75.0,
    old_price: 105.0,
  },
  {
    id: 2,
    name: "Boho Chic Women's Peasant Maxi Dress",
    category: "women",
    image: p2_img,
    new_price: 75.0,
    old_price: 100.5,
  },
  {
    id: 17,
    name: "Men's Tailored Formal Trousers for Professional Wear",
    category: "men",
    image: p17_img,
    new_price: 80.0,
    old_price: 120.5,
  },
  {
    id: 28,
    name: "Smart Kid's Three-Piece Suit for Formal Occasions",
    category: "kid",
    image: p28_img,
    new_price: 50.0,
    old_price: 85.5,
  },
];


export default new_collections;
